import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';

import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { MatCheckboxModule } from '@angular/material/checkbox';

import { DocumentTypeFormAutoCompleteModule } from '../../chipList/DocumentType/DocumentType.module';

import { ActTypeFormAutoCompleteModule } from '../../chipList/ActType/ActType.module';

import { ParameterDocumentLinkFormComponent } from './ParameterDocumentLink.component';

@NgModule({
  declarations: [ParameterDocumentLinkFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,

    MatInputModule,
    MatSelectModule,

    MatCheckboxModule,

    DocumentTypeFormAutoCompleteModule,

    ActTypeFormAutoCompleteModule
  ],
  exports: [
    ParameterDocumentLinkFormComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,

    MatInputModule,
    MatSelectModule,

    MatCheckboxModule,

    DocumentTypeFormAutoCompleteModule,

    ActTypeFormAutoCompleteModule
  ]
})
export class ParameterDocumentLinkFormModule {}
